import {Component, OnInit} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {AnchorNavigationItem} from '../../components/anchor-navigation/anchor-navigation.component';
import {ComplianceCalculateService} from '../../services/wizard-form-groups-services/compliance-calculate.service';

@Component({
    selector: 'app-wizard-laboratory-staff',
    template: `
        <app-wizard-content>
            <ng-container sticky>
                <app-anchor-navigation [items]="anchors"></app-anchor-navigation>

                <p><small>Область аттестации <br>лаборатории</small></p>
                <table class="table" style="width: 100%; max-width: 190px">
                    <tbody>
                        <tr *ngFor="let item of (complianceService.complianceTableData$ | async)">
                            <td style="padding: 2px 0; width: 45px">
                                <small>{{item.title}}<sup *ngIf="item.submetodsTitles?.length">*</sup></small>
                            </td>
                            <td style="padding: 2px 0 2px 10px">
                                <small>{{item.choosenObjects.join(', ')}}</small>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <fieldset id="staff-list">
                <small>
                    Для аттестации лаборатории необходимо чтобы область аттестации сотрудников
                    суммарно покрывала область аттестации лаборатории.
                </small>
            </fieldset>
            <app-wizard-staff-list></app-wizard-staff-list>
            <hr class="form-page-view__divider" style="margin-top: 0">
            <fieldset id="compliance-table">
                <compliance-table></compliance-table>
            </fieldset>
        </app-wizard-content>
    `
})

export class LaboratoryStaffComponent extends AbstractFields implements OnInit {
    public anchors: AnchorNavigationItem[] = [
        {title: 'Персонал лаборатории', anchor: 'staff-list', active: true},
        {title: 'Таблица соответствия', anchor: 'compliance-table', active: false},
    ];

    constructor(
        public complianceService: ComplianceCalculateService,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
    }

}
